import React, { FC, useState } from 'react';
import useTranslations from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import ContentTemplate from '../../ui/Content/Content';
import { Company, CompanyLabel, Contact, ContactMap, Gallery, Image, Map } from './Address.elements';

export interface AddressProps {}

const AddressTemplate: FC<AddressProps> = () => {
    const { t } = useTranslations();

    return (
        <ContentTemplate withPadding mobileSidePadding={20}>
            <Title tagType={TitleTagTypes.H2} isBlack>
                {t('contact.company.title')}
            </Title>
            <Contact>
                <Company>
                    <CompanyLabel $isBold>Poradca podnikateľa, spol. s r.o.</CompanyLabel>
                    <CompanyLabel $marginTop={10}>Martina Rázusa 23A/8336</CompanyLabel>
                    <CompanyLabel>010 01 Žilina</CompanyLabel>
                    <CompanyLabel $marginTop={20}>IČO: 31 592 503</CompanyLabel>
                    <CompanyLabel>IČ DPH: SK2020449189</CompanyLabel>
                    <CompanyLabel>DIČ: 2020449189</CompanyLabel>
                    <CompanyLabel $marginTop={20}>
                        Spoločnosť je zapísaná v Obchodnom registri Okresného súdu v Žiline
                    </CompanyLabel>
                    <CompanyLabel>Oddiel: Sro, Vložka číslo: 1408/L</CompanyLabel>
                    <CompanyLabel $marginTop={20}>
                        <strong>GPS Súradnice</strong>: 49.223234, 18.726129
                    </CompanyLabel>
                    <CompanyLabel $marginTop={10}>
                        V PP Centre sú k dispozícií školiace miestnosti, reštaurácia a veľkokapacitné parkovisko.
                    </CompanyLabel>
                </Company>
                <Map>
                    <ContactMap
                        dangerouslySetInnerHTML={{
                            __html: '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10423.236606072716!2d18.7262033!3d49.2231464!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47145ea1ffd7690f%3A0xab748f87e789e96e!2sPoradca%20podnikate%C4%BEa%2C%20spol.%20s%20r.%20o.%2C!5e0!3m2!1ssk!2ssk!4v1695899211067!5m2!1ssk!2ssk" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
                        }}
                    ></ContactMap>
                </Map>
            </Contact>
            <Gallery>
                <Image src={publicAssets('/contact_image1.webp')} />
                <Image src={publicAssets('/contact_image3.webp')} />
            </Gallery>
        </ContentTemplate>
    );
};

export default AddressTemplate;
